import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get, map, size, cloneDeep } from "lodash";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PrintIcon from '@material-ui/icons/Print';
import TabContext from '@material-ui/lab/TabContext';

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";
import { fetchGet, fetchPost, fetchPut } from "../../api/fetch";
import { setBreadcrumb as setBreadcrumbs } from "../../actions/common";
import { toggleZone, expandZone, initiateExpandZone, contractZone } from "../../actions/zones";
import {
  getQueryStringValue,
  setQueryStringValue,
  clearQueryStringValue
} from "../../utils/queryString";
import {
  printZebraLabel,
  printZebraLabels,
  needUserSelectPrinter,
  getLabelPrinterDevices,
  setPrinterWidthConfig,
  selectPrinter
} from "../../utils/labels";
import CustomInput from "../Common/CustomInput";
import ScrollableTable from "../Common/Table/ScrollableTable";
import CustomSelect from "../Common/CustomSelect";
import CloseIcon from "../Common/CloseIcon";
import NuvButton from "../Common/NuvButton";
import PaperLightGrey from "../Common/PaperLightGrey";
import NuvTabList from "../Common/NuvTabList"
import NuvTab from "../Common/NuvTab";
import NuvTabPanel from "../Common/NuvTabPanel";
import EditWarning from "./EditWarning";
import MessageDialog, { MessageStatus } from "../Common/MessageDialog";
import ZoneTreeRow from "./ZoneTreeRow";
import ProductAssociation from "./ProductAssociation";
import ZoneCreation from './ZoneCreation'
import ZoneDelete from "./ZoneDelete";
import PrinterSelection from "./PrinterSelection";
import BulkPrintConfirmation from "./BulkPrintConfirmation";
import ZoneDevicePanel from "../Devices/ZoneDevicePanel";
import ScanPopup from "../VMI/ScanPopup"
import ProductSearch from "../VMI/ProductSearch";
import { MenuItem, Select } from "@material-ui/core";
import {
  ZONE_TYPE,
  ZONE_TYPES_WITH_INVENTORY_ICON,
  ZONE_TYPES_WITH_EDITABLE_NAMES,
  ZONE_TYPES_WITH_BULK_BIN_LABEL_PRINT,
  ZONE_ATTR,
  ZONE_RESPONSIBILITY_CENTER_OPTIONS
} from "../../constants/zones";
import { UNIT_OF_MEASURE } from "../../constants/attributes";

const styles = {
  treeContent: {
    height: "calc(100vh - 148px)",
    maxWidth: "360px",
    margin: "24px",
    padding: "4px",
    minHeight: 0,
    overflow: "auto",
  },
  zoneContent: {
    marginLeft: 40,
    height: "calc(100vh - 148px)",
    margin: "24px",
    padding: "4px",
    minHeight: 0,
    overflowY: "hidden",
  },
  zoneContentExpanded: {
    marginLeft: 0,
    height: "calc(100vh - 148px)",
    margin: "24px",
    padding: "4px",
    minHeight: 0,
    overflowY: "hidden",
  },
  detailsTitle: {
    width: 300,
    height: 50,
    backgroundColor: "#f8f8f8",
    border: "1px solid",
    borderColor: colors.black20,
    paddingTop: 16,
    paddingLeft: 8,
    marginLeft: 2,
    display: "flex"
  },
  details: {
    width: 300,
    height: "calc(100vh - 245px)",
    backgroundColor: "#f8f8f8",
    border: "1px solid",
    borderColor: colors.black20,
    paddingTop: 12,
    paddingLeft: 8,
    float: "left",
    marginLeft: 2,
    overflowY: "auto",
    overflowX: "hidden"
  },
  details2: {
    width: 300,
    height: "calc(100vh - 205px)",
    backgroundColor: "#f8f8f8",
    border: "1px solid",
    borderColor: colors.black20,
    paddingTop: 12,
    paddingLeft: 8,
    float: "left",
    marginLeft: 2,
    overflowY: "auto",
    overflowX: "hidden"
  },
  subHeader: {
    fontSize: 14,
    color: colors.black87,
    fontWeight: 500,
    marginLeft: 8,
  },
  detailHeader: {
    fontSize: 14,
    color: colors.black87,
    fontWeight: 500,
    paddingBottom: 24
  },
  detailDiv: {
    paddingBottom: 24,
    paddingLeft: 8
  },
  bulkPrintDiv: {
    paddingBottom: 8,
  },
  bulkPrintHeader: {
    fontSize: 12,
    color: colors.black54,
    fontWeight: 500,
  },
  detailRight: {
    width: "calc(100vw - 850px)",
    maxWidth: 1000,
    backgroundColor: colors.lightGrey,
  },
  detailsTitle3: {
    width: "calc(100vw - 850px)",
    height: 48,
    maxWidth: 998,
    backgroundColor: "#f8f8f8",
    borderBottom: "1px solid",
    borderBottomColor: colors.black20,
  },
  detailsProduct: {
    width: "calc(100vw - 852px)",
    height: "calc(100vh - 297px)",
    backgroundColor: "#f8f8f8",
    borderTop: "1px solid",
    borderTopColor: colors.black20,
    maxWidth: 998,
    overflowY: "auto",
    overflowX: "hidden"
  },
  detailsProduct2: {
    width: "calc(100vw - 852px)",
    height: "calc(100vh - 207px)",
    backgroundColor: "#f8f8f8",
    maxWidth: 998,
    borderTop: "1px solid",
    borderTopColor: colors.black20,
    overflowY: "auto",
    overflowX: "hidden"
  },
  detailsProduct3: {
    width: "calc(100vw - 852px)",
    height: "calc(100vh - 297px)",
    backgroundColor: "#f8f8f8",
    maxWidth: 998,
    borderTop: "1px solid",
    borderTopColor: colors.black20,
    overflowY: "auto",
    overflowX: "hidden"
  },
  detailParent: {
    width: "100%",
  },
  editButton: {
    top: -7
  },
  editButton2: {
    top: -9
  },
  scannerButton: {
    top: -2,
  },
  paginationDropdown: {
    backgroundColor: "white",
    height: "36px",
    width: "240px",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    fontSize: "14px",
    "& > .MuiSelect-select": {
      paddingLeft: "6px",
    },
    "& > .MuiSelect-icon": {
      top: "calc(50% - 11px)"
    }
  },
};

const Zone = (props) => {
  const { classes, dispatch, language, history, zones } = props;
  const [tree, setTree] = React.useState();
  const [zoneAttributes, setZoneAttributes] = React.useState({});
  const [zoneAttributesTmp, setZoneAttributesTmp] = React.useState({});
  const [editMode, setEdit] = React.useState(false);
  const [deleteZone, setDeleteZone] = React.useState(false);
  const [scanDialog, setOpenScan] = React.useState(false);
  const [scanError, setScanError] = React.useState("");
  const [changeViewDialog, setChangeViewDialog] = React.useState(false);
  const zoneId = get(props, ["match", "params", "zoneId"]);
  const zoneIdRef = React.useRef(zoneId);
  zoneIdRef.current = get(props, ["match", "params", "zoneId"]);
  const [currentZoneName, setSelectedZoneName] = React.useState();
  const [currentZoneNameTmp, setSelectedZoneNameTmp] = React.useState();
  const [currentZoneBranchName, setSelectedZoneBranchName] = React.useState();
  const [currentZoneType, setSelectedZoneType] = React.useState();
  const [currentZoneIDType, setSelectedZoneIDType] = React.useState();
  const [searchDialogue, setOpenSearch] = React.useState(false);
  const [currentZoneID, setSelectedZoneID] = React.useState();
  const [currentSiteID, setSelectedSiteID] = React.useState();
  const [currentCompanyID, setSelectedCompanyID] = React.useState();
  const [zoneCreation, createZone] = React.useState(false);
  const [editWarning, setEditWarning] = React.useState(false);
  const [currentNode, setCurrentNode] = React.useState();
  const [products, setProducts] = React.useState([]);
  const [editProductAssociation, setEditProductAssociation] = React.useState();
  const [editWarningProductAssociation, setEditWarningProductAssociation] = React.useState();
  const [editPZIZoneNavigate, setEditPZIZoneNavigate] = React.useState(false);

  // Device Edit Mode
  const [isEditMode, setEditMode] = React.useState(false);
  const [expandedZones, setExpandedZones] = React.useState();
  const [isAwaitingRequest, setIsAwaitingRequest] = React.useState(false);

  const zonesRef = React.useRef(zones);
  zonesRef.current = zones;

  const [triggeredByScan, _setTriggeredByScan] = React.useState(false);
  const triggeredByScanRef = React.useRef(triggeredByScan);
  const setTriggeredByScan = (data) => {
    triggeredByScanRef.current = data;
    _setTriggeredByScan(data);
  }

  React.useEffect(() => {
    if (get(props.zones, 'root')) {
      if (get(props.zones.root, 'expandedZones') && props.zones.root.expandedZones.length > 0) {
        setQueryStringValue("expandedZones", props.zones.root.expandedZones);
        setExpandedZones(props.zones.root.expandedZones);
      } else {
        clearQueryStringValue("expandedZones");
        setExpandedZones([]);
      }
    }
  }, [props.zones, props.zones.root]);

  React.useEffect(() => {
    // Note: this is only run once on page refresh

    // see if there are any expanded zones in the query string
    let newZones = getQueryStringValue("expandedZones");
    if (newZones) {
      dispatch(initiateExpandZone("root", newZones));
    }

    fetchDistUnitMeasurements();
    fetchMassUnitMeasurements();
    fetchMaxLevels();
    fetchMinLevels();

    let unlistenHistory = props.history.listen(() => {
      // Note:  This is triggered whenever the application updates the URL
      // It will be triggered even when the url does not change.

      // Rebuild the queryString of the URL from the props
      let currentExpandedZones = zonesRef.current.root.expandedZones || '';
      if (size(currentExpandedZones) > 0) {
        setQueryStringValue("expandedZones", currentExpandedZones);
      }
      // now check to see if this nav was caused by a scan
      // and if so scroll the selected zone into view on the tree
      if (triggeredByScanRef.current) {
        setTriggeredByScan(false);
        autoExpandToZone(parseInt(zoneId));
        setScrollToSelected(true);
      }
    });

    // Since this is fired on first load of the page, Make sure we scroll
    // the selected zone into view.
    setScrollToSelected(true);

    return () => {
      unlistenHistory();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    // NOTE! This is triggered whenever the zoneId in the URL changes;
    navigateToZone('', zoneId);
    if (isTreeDirty) {
      fetchZoneTree(zoneId);
      // TODO: filter out the zones in the expanded zones that are not in
      // the new zone tree and re-build the URL query string.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneId]);

  const [newZoneName, setNewZoneName] = React.useState();
  const [newZoneID, setNewZoneID] = React.useState();

  //-----------------------------------------------------------------------
  // Picklist states and functions
  //-----------------------------------------------------------------------

  const [distUnitMeasurements, setDistUnitMeasurements] = React.useState();
  const [distUnitsAsObj, setDistUnitsAsObj] = React.useState();
  const [massUnitsAsObj, setMassUnitsAsObj] = React.useState({});
  const [massUnitMeasurements, setMassUnitMeasurements] = React.useState();
  const [minQuantLevelOptions, setMinQuantLevelOptions] = React.useState([]);
  const [maxQuantLevelOptions, setMaxQuantLevelOptions] = React.useState([]);

  const fetchDistUnitMeasurements = async () => {
    try {
      let minLevel = await fetchGet(
        `/attributes/255`
      );

      minLevel = minLevel["values"]
      let unitObj = {}
      let units = []
      for (let i in minLevel) {
        let option = minLevel[i]
        unitObj[option["id"]] = option[`name_${language}`]
        units.push({
          id: option["id"],
          name: option[`name_${language}`]
        })
      }

      setDistUnitsAsObj(unitObj)
      setDistUnitMeasurements(units)
    } catch (error) {
      console.log("Zone Page: error initializing units of measure:\n" + error.message)
    }
  }

  const fetchMassUnitMeasurements = async () => {
    try {
      let res = await fetchGet(
        `/attributes/241`
      );
      res = res["values"]
      var unitObj = {}
      var units = []
      for (let i in res) {
        var option = res[i]
        unitObj[option["id"]] = option[`name_${language}`]
        units.push({
          id: option["id"],
          name: option[`name_${language}`]
        })
      }
      setMassUnitsAsObj(unitObj)
      setMassUnitMeasurements(units)

    } catch (e) {
      console.log(e);
    }
  }


  // REFERENCE FOR ATTRIBUTE OPTIONS FETCH
  const fetchMinLevels = async () => {
    try {
      let minLevel = await fetchGet(
        `/attributes/238`
      );
      minLevel = minLevel["values"]
      var levels = []

      for (let i in minLevel) {
        var option = minLevel[i]
        levels.push({
          id: option["id"],
          name: option[`name_${language}`]
        })

      }
      setMinQuantLevelOptions(levels)

    } catch (e) {
      console.log(e);
    }
  }

  const fetchMaxLevels = async () => {
    try {
      let maxLevel = await fetchGet(
        `/attributes/239`
      );
      maxLevel = maxLevel["values"]
      var levels = []

      for (let i in maxLevel) {
        var option = maxLevel[i]
        levels.push({
          id: option["id"],
          name: option[`name_${language}`]
        })

      }
      setMaxQuantLevelOptions(levels)

    } catch (e) {
      console.log(e);
    }
  }

  //-----------------------------------------------------------------------
  // Zone loading and maintenance functions and states
  //-----------------------------------------------------------------------

  const [tmpWarningZoneName, setTmpWarningZoneName] = React.useState();
  const [tmpWarningZoneID, setTmpWarningZoneID] = React.useState();

  // New zone Attributes *Added by Andrew - please replace old attributes
  const [zoneAttr, setZoneAttr] = React.useState([])

  async function navigateToZone(zone_name, zone_id, warning = false) {
    if (editProductAssociation !== undefined && !warning || isEditMode && !warning) {
      setEditPZIZoneNavigate(true)
      setTmpWarningZoneName(zone_name);
      setEditWarning(true)
      setTmpWarningZoneID(zone_id)
      return
    }
    //console.log(zone_name, warning)
    if (editMode && !warning) {
      setEditWarning(true)
      setNewZoneName(zone_name)
      setNewZoneID(zone_id)
      return
    }
    setEdit(false)

    fetchProductZoneInventories(zone_id);

    try {
      let zone = await fetchGet(
        `zones/${zone_id}`
      );

      setSelectedZoneName(zone['name']);
      setSelectedZoneNameTmp(zone['name']);
      setSelectedZoneID(typeof zone_id === 'string' ? parseInt(zone_id) : zone_id);
      setSelectedSiteID(zone['site_id']);
      setSelectedCompanyID(zone['company_id']);
      setSelectedZoneType(zone['type'][`name_${language}`]);
      setSelectedZoneIDType(zone['type']['id']);
      setRootZoneId(zone['root_zone_id']);

      buildBreadcrumbs(zone);

      let zone_attributes = zone["attributes"];

      var reduced = zone_attributes.reduce(function (filtered, option) {
        if (option["app_display_main_page"]) {
          filtered.push(option);
        }
        return filtered;
      }, []);

      var attributes = {}

      for (let i in reduced) {
        attributes[i] = reduced[i]
      }
      setZoneAttributes(attributes);
      setZoneAttributesTmp(cloneAttributes(attributes))

      // Save Replenishment Option to State
      for (const att in zone_attributes) {
        if (zone_attributes[att]["id"] === 280) {
          setReplenishmentOption(zone_attributes[att].value)

        }
      }

      if (zone_attributes.filter(za => za.id === 269)[0]) {
        if (zone_attributes.filter(za => za.id === 269)[0].value) {
          setReplenishmentHours(parseInt(zone_attributes.filter(za => za.id === 269)[0].value))

        } else {
          setReplenishmentHours(0)
        }
      }

      fetchGet(`attributes/280`)
        .then(data => {
          setReplenishmentOptionList(data.values.filter(v => v.active === true))
        })
        .catch(e => console.error(e))

      setCurrentNode({
        'id': zone['id'],
        'site_id': zone['site_id'],
        'company_id': zone['company_id'],
        'parent_zone_id': zone['parent_zone_id'],
        'name': zone['name']
      });

    } catch (error) {
      console.log("error getting zone and attributes:\n" + error.message)
    }
  }

  function cloneAttributes(attributes) {
    let newAttributes = Object.values(cloneDeep(attributes));
    // Note if the unit of measure attribute is missing, make sure it
    // is configured to the default value.
    let idx = newAttributes.findIndex(element => element['id'] === ZONE_ATTR.UNIT_OF_MEASURE);
    if (idx > -1 && !newAttributes[idx].value)
      newAttributes[idx].value = UNIT_OF_MEASURE.IN;

    return newAttributes;
  }

  async function fetchProductZoneInventories(zone_id) {
    try {
      let products_zones = await fetchGet(
        `/product_zone_inventories?zone=${zone_id}&limit=100`
      );
      setProducts(products_zones)

    } catch (error) {
      console.log(error)
    }
  }

  async function saveEdit(zone_name = currentZoneName, zoneID = currentZoneID, warning = false) {
    try {
      let attributes = []
      let depth = false;
      let height = false;
      let width = false;
      let unitSet = false;
      for (let i in zoneAttributesTmp) {
        if (zoneAttributesTmp[i]["id"] === 252 && zoneAttributesTmp[i]["value"]) {
          depth = true;
        }
        if (zoneAttributesTmp[i]["id"] === 253 && zoneAttributesTmp[i]["value"]) {
          width = true;
        }
        if (zoneAttributesTmp[i]["id"] === 254 && zoneAttributesTmp[i]["value"]) {
          height = true;
        }
        if (zoneAttributesTmp[i]["id"] === 255 && zoneAttributesTmp[i]["value"]) {
          unitSet = true
        }
        if (zoneAttributesTmp[i]["value"] && zoneAttributesTmp[i]["data_type"] === "integer") {
          zoneAttributesTmp[i]["value"] = parseInt(zoneAttributesTmp[i]["value"])
        }
        if (zoneAttributesTmp[i]["value"] && zoneAttributesTmp[i]["data_type"] === "float") {
          zoneAttributesTmp[i]["value"] = parseFloat(zoneAttributesTmp[i]["value"])
        }
        if (zoneAttributesTmp[i]["id"] === 280 && replenishmentOption !== 0) {
          zoneAttributesTmp[i]["value"] = replenishmentOption;

          if (zoneAttributesTmp[i]["value"] === 167) {

            attributes.push({
              id: 269,
              value: replenishmentHours ? replenishmentHours.toString() : null,
            })
            attributes.push({
              id: 270,
              value: true,
            })
          } else {
            attributes.push({
              id: 269,
              value: null,
            })
            attributes.push({
              id: 270,
              value: false,
            })
          }
        }
        if (zoneAttributesTmp[i]["value"] || zoneAttributesTmp[i]["required"]) {
          attributes.push(zoneAttributesTmp[i])
        }

      }


      if (!([depth, width, height, unitSet].every((val, i, arr) => val === arr[0]))) {
        setMessage(I18n.get("unit_required"));
        setMessageStatus(MessageStatus.WARNING);
        setOpenMessage(true);
        fetchRootTree();
        setEdit(true)
        return
      }

      if (attributes.some(attr => attr["required"] && !attr["value"])) {
        setMessage(I18n.get("site_pleaseFillRequiredFields"));
        setMessageStatus(MessageStatus.WARNING);
        setOpenMessage(true);
        fetchRootTree();
        setEdit(true)
        return
      }

      if (hasSiblingSameName(currentZoneNameTmp)) {
        setMessage(I18n.get("zone_same_name_warning"));
        setMessageStatus(MessageStatus.WARNING);
        setOpenMessage(true);
        fetchRootTree();
        setEdit(true)
        return
      }
      console.log(attributes)
      var body = {
        "active": true,
        "name": currentZoneNameTmp,
        "attributes": attributes,
      }
      let res = await fetchPut(`/companies/${currentCompanyID}/sites/${currentSiteID}/zones/${currentZoneID}`, body);

      if (res.are_there_orders_in_progress && currentZoneName !== currentZoneNameTmp) {
        setMessage(I18n.get("order_in_progress_warning"));
        setMessageStatus(MessageStatus.ERROR);
        setOpenMessage(true);
      }

      // Note: We're staying on the same zone but IT may have changed so...
      fetchRootTree();
      navigateToZone(zone_name, zoneID, warning);
    } catch (error) {
      console.log(error)
    }
  }

  function cancelEdit() {
    setSelectedZoneNameTmp(currentZoneName);
    setZoneAttributesTmp(cloneAttributes(zoneAttributes));
  }

  //-----------------------------------------------------------------------
  // Zone Tree expansion functions
  //-----------------------------------------------------------------------

  const onToggleZone = (zoneId) => {
    // Dispatch action
    dispatch(toggleZone("root", zoneId));
  };

  const onExpandZone = (zoneId) => {
    // Dispatch action
    dispatch(expandZone("root", zoneId));
  };

  //-----------------------------------------------------------------------
  // Product Zone Inventory Association functions
  //-----------------------------------------------------------------------

  async function associateProduct(product) {
    setIsAwaitingRequest(true)
    try {
      var body = {
        "zone_id": currentZoneID,
        "product_id": product["product_id"],
        "assigned_company_id": currentCompanyID,
        "active": true,
        "quantity": null,
        "last_event_id": null,
        // "pzi_id": product["pzi_id"],
        "attributes": []
      }
      await fetchPost(
        `product_zone_inventory`, body
      );
      fetchRootTree(); // Force re-load of the tree in case icon changes
      fetchProductZoneInventories(currentZoneID);
      if (currentZoneIDType === 37) {
        setTimeout(() => setIsAwaitingRequest(false), 2000)
      } else {
        setIsAwaitingRequest(false)
      }
    } catch (error) {
      console.log("failed to create product association.")
    }

  }

  //-----------------------------------------------------------------------
  // Breadcrumb functions
  //-----------------------------------------------------------------------

  function buildBreadcrumbs(zone) {
    let companyName = zone['company_name'];
    let siteName = zone['site_name'];
    let rootZoneName = zone['root_zone_name'];
    let breadcrumb = [
      {
        name: "wms",
        display: false,
      },
      {
        name: I18n.get("topbar_vmi_config"),
      },
    ];
    breadcrumb.push({
      name: companyName,
      subName: I18n.get("companies_company"),
    });
    breadcrumb.push({
      name: siteName,
      subName: I18n.get("common_site"),
    });
    breadcrumb.push({
      name: rootZoneName,
      subName: I18n.get("companies_zone")
    });
    dispatch(setBreadcrumbs(breadcrumb));
  }

  //-----------------------------------------------------------------------
  // Page navigation functions
  //-----------------------------------------------------------------------

  function goTo(zoneId) {
    // We're about to navigate to different zone, update the url to reflect our destination
    let url = `/wms/vmi-configuration/${zoneId}`;
    history.push(url);
  }

  //-----------------------------------------------------------------------
  // Tree functions and states
  //-----------------------------------------------------------------------
  const [rootZoneId, setRootZoneId] = React.useState();
  const [isFetchingTree, setIsFetchingTree] = React.useState(false);
  const [isTreeDirty, setTreeDirty] = React.useState(true);
  const [scrollToSelected, setScrollToSelected] = React.useState(true);
  const [flatTree, _setFlatTree] = React.useState();
  const flatTreeRef = React.useRef(flatTree);
  const setFlatTree = (data) => {
    flatTreeRef.current = data;
    _setFlatTree(data);
  }



  // The following is useful for debugging scrolling
  // React.useEffect(() => {
  //   if (scrollToSelected) {
  //     console.log('flag to scroll');
  //   } else {
  //     console.log('finished scrolling');
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [scrollToSelected]);

  React.useEffect(() => {
    if (!rootZoneId)
      return;
    if (tree) {
      if (tree[0]['id'] === rootZoneId) {
        return;
      }
    }
    // Root zone changed AND the tree's root does not match
    fetchRootTree(rootZoneId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootZoneId]);

  React.useEffect(() => {
    if (flatTreeRef.current && zoneIdRef.current) {
      setSelectedZoneBranchName(getBranchBreadcrumbs(zoneIdRef.current));

      // The only things that would force the
      // setting of the flatTree would be the loading of the
      // page or the reloading of a new tree.
      // In both these cases we would want to force an auto
      // expand of the currently selected branch in it's entirety
      autoExpandToZone(zoneIdRef.current);
      autoRemoveExpandedNotInTree();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flatTree, zoneId]);

  const autoExpandToZone = (zoneId) => {
    // 1. determine all nodes to expand
    let nodesToExpand = getBranchNodeIds(zoneId);
    // 2. Force these nodes open
    if (nodesToExpand) {
      for (let nodeId in nodesToExpand) {
        onExpandZone(parseInt(nodesToExpand[nodeId]));
      }
    }
  }

  const autoRemoveExpandedNotInTree = () => {
    if (expandedZones) {
      for (let expandedZoneKey in expandedZones) {
        let expandedZoneId = expandedZones[expandedZoneKey];
        if (!(expandedZoneId in flatTree)) {
          dispatch(contractZone("root", expandedZoneId));
        }
      }
    }
  }

  const getBranchNodeIds = (zoneId) => {
    let nodes = [];
    if (zoneId) {
      addZoneId(nodes, zoneId);
    }
    return nodes;
  }

  const addZoneId = (nodes, zoneId) => {
    if (flatTreeRef.current[zoneId] && flatTreeRef.current[zoneId]['hasChilds']) {
      nodes.push(zoneId)
    }
    if (flatTreeRef.current[zoneId] && flatTreeRef.current[zoneId]['parent_zone_id']) {
      addZoneId(nodes, flatTreeRef.current[zoneId]['parent_zone_id']);
    }
  }

  const fetchRootTree = async () => {
    try {
      if (!tree) {
        setIsFetchingTree(true);
      }

      let res = await fetchGet(
        `zone_tree/${rootZoneId}?active=true`
      );
      setTree({
        ...res
      });
      setupFlatTree(res);
    } catch (e) {
      console.log(e);
    }
    setIsFetchingTree(false);
    setTreeDirty(false);
    setScrollToSelected(true);
  }

  const fetchZoneTree = async (zoneId) => {
    try {
      if (!tree) {
        setIsFetchingTree(true);
      }

      let res = await fetchGet(
        `zone_tree/zone/${zoneId}?active=true`
      );
      setTree({
        ...res
      });
      setupFlatTree(res);
      setRootZoneId(res[0]['id']);
    } catch (e) {
      console.log(e);
    }
    setIsFetchingTree(false);
    setTreeDirty(false);
  }

  const setupFlatTree = (tree) => {
    let newFlatTree = {};
    setupSubTree(newFlatTree, tree[0]);
    setFlatTree(newFlatTree);
  }

  const setupSubTree = (newFlatTree, subTree) => {
    let hasChilds = get(subTree, 'childs') && subTree.childs.length > 0;
    newFlatTree[subTree.id] = {
      name: subTree.name,
      parent_zone_id: subTree.parent_zone_id,
      hasChilds: hasChilds
    }
    if (subTree.childs && subTree.childs.length > 0) {
      for (let i = 0; i < subTree.childs.length; i++) {
        setupSubTree(newFlatTree, subTree.childs[i]);
      }
    }
  }

  const getBranchBreadcrumbs = (id) => {
    if (!id) return '';
    if (!(id in flatTree)) return '';
    let zoneNames = [];
    getBranchNode(zoneNames, id);
    return zoneNames.join(' > ');
  }

  const getBranchNode = (zoneNames, id) => {
    zoneNames.unshift(flatTree[id].name);
    if (flatTree[id].parent_zone_id) {
      getBranchNode(zoneNames, flatTree[id].parent_zone_id);
    }
  }

  //-----------------------------------------------------------------------
  // Sibling name checking mechanims
  //-----------------------------------------------------------------------
  // This is used to validate that you are not renaming a zone to the same
  // same name as one of it's siblings

  const [siblingNames, setSiblingNames] = React.useState([]);

  // Build a list of siblings to the currently selected node
  React.useEffect(() => {
    if (!flatTree) { setSiblingNames([]); return; }
    if (!currentNode) { setSiblingNames([]); return; }
    let selectedZoneId = currentNode['id'];
    let selectedParentId = currentNode['parent_zone_id'];
    let names = [];
    for (const [zoneId, ftZone] of Object.entries(flatTree)) {
      if (ftZone['parent_zone_id'] === selectedParentId && parseInt(zoneId) !== selectedZoneId) {
        names.push(ftZone['name']);
      }
    }
    setSiblingNames(names);
  }, [flatTree, currentNode]);

  // Check to see if the new name is already taken by a sibling
  // returns: true or false
  function hasSiblingSameName(newName) {
    if (siblingNames.length < 1) return false;
    let hasSameName = false;
    if (siblingNames.includes(newName)) hasSameName = true;
    return hasSameName;
  }

  //-----------------------------------------------------------------------
  // Printer Select Dialog related states and functions
  //
  // TODO: All of this should be incorporated int a button component.
  // That way it could be reused at different locations conviniently.
  //-----------------------------------------------------------------------
  const [selectPrinterDialog, setOpenSelectPrinter] = React.useState(false);
  const [labelWidth, setLabelWidth] = React.useState();
  const [labelPrinterDevices, setLabelPrinterDevices] = React.useState();
  const [printingBusy, setPrintingBusy] = React.useState(false);
  // Bulk bin printing: labels already fetched and awaiting a confirmation, then
  // possibly a printer selection. Null when the pending printing is the zone
  // label itself.
  const [bulkPrintFormat, setBulkPrintFormat] = React.useState(null);
  const [pendingBulkLabels, setPendingBulkLabels] = React.useState(null);
  const [bulkPrintDialog, setBulkPrintDialog] = React.useState(false);
  const bulkLabel2x1 = I18n.get("label_printer_format_2x1");
  const bulkLabel4x1 = I18n.get("label_printer_format_4x1");
  const canBulkPrintBinLabels = ZONE_TYPES_WITH_BULK_BIN_LABEL_PRINT.includes(currentZoneIDType);

  const fetchLabel = async (zoneId) => {
    try {
      let res = await fetchGet(
        `v2/labels/zone/${zoneId}`
      );
      return { ...res };
    } catch (e) {
      console.log(e);
    }
  }

  // Every label of every bin held by the current level, in the given format.
  const fetchBinLabels = async (zoneId, format) => {
    try {
      return await fetchGet(
        `v2/labels/zone/${zoneId}/bins?labelSize=${format}`
      );
    } catch (e) {
      console.log(e);
      return undefined;
    }
  }

  async function printLabel() {
    console.log("print label zone")
    setBulkPrintFormat(null);
    setPendingBulkLabels(null);
    setPrintingBusy(true);
    let label = await fetchLabel(zoneId);
    let askUser = await needUserSelectPrinter(label);
    let width = label['label-width'];
    let devices = getLabelPrinterDevices();

    if (askUser) {
      setLabelPrinterDevices(devices);
      setLabelWidth(width);
      setOpenSelectPrinter(true);
    } else {
      if (devices.length < 1) {
        setMessage(I18n.get("label_printer_not_found"));
        setMessageStatus(MessageStatus.NAKED);
        setOpenMessage(true);
      } else {
        selectPrinter(label);
        let status = printZebraLabel(label);

        if (status['status'] !== 200) {
          setMessage(I18n.get("label_printer_error") + width + I18n.get("label_printer_error_2"));
          setMessageStatus(MessageStatus.ERROR);
          setOpenMessage(true);
        }
        console.log("Print label status:" + JSON.stringify(status));
      }
    }
    setPrintingBusy(false);
  }

  // Step 1: fetch the label of every product association found in the bins of
  // the current level (drawer, shelf or wall), then ask for a confirmation
  // since a level can hold a few hundred of them.
  async function requestBinLabelsPrint(format) {
    console.log("request bin labels in bulk: " + format);
    setPrintingBusy(true);

    let labels = await fetchBinLabels(currentZoneID, format);

    if (!labels) {
      setMessage(I18n.get("label_printer_bulk_error"));
      setMessageStatus(MessageStatus.ERROR);
      setOpenMessage(true);
      setPrintingBusy(false);
      return;
    }

    if (labels.length < 1) {
      setMessage(I18n.get("label_printer_bulk_empty"));
      setMessageStatus(MessageStatus.NAKED);
      setOpenMessage(true);
      setPrintingBusy(false);
      return;
    }

    setBulkPrintFormat(format);
    setPendingBulkLabels(labels);
    setBulkPrintDialog(true);
    setPrintingBusy(false);
  }

  function cancelBinLabelsPrint() {
    setBulkPrintDialog(false);
    setBulkPrintFormat(null);
    setPendingBulkLabels(null);
  }

  // Step 2: the user confirmed, send the whole batch to the printer.
  async function printBinLabels(labels) {
    if (!labels || labels.length < 1) return;

    setBulkPrintDialog(false);
    setPrintingBusy(true);

    // Every label of the batch shares the same width, the printer only needs
    // to be resolved once.
    let askUser = await needUserSelectPrinter(labels[0]);
    let width = labels[0]['label-width'];
    let devices = getLabelPrinterDevices();

    if (askUser) {
      setLabelPrinterDevices(devices);
      setLabelWidth(width);
      setOpenSelectPrinter(true);
    } else {
      if (!devices || devices.length < 1) {
        setMessage(I18n.get("label_printer_not_found"));
        setMessageStatus(MessageStatus.NAKED);
        setOpenMessage(true);
      } else {
        selectPrinter(labels[0]);
        let status = await printZebraLabels(labels);

        if (status['status'] !== 200) {
          setMessage(I18n.get("label_printer_error") + width + I18n.get("label_printer_error_2"));
          setMessageStatus(MessageStatus.ERROR);
          setOpenMessage(true);
        }
        console.log("Print bin labels status:" + JSON.stringify(status));
      }
      setBulkPrintFormat(null);
      setPendingBulkLabels(null);
    }
    setPrintingBusy(false);
  }

  function updatePrinterWidthConfig(selectedPrinterUUID) {
    // The user confirmed a selection, update the config.
    setPrinterWidthConfig(labelWidth, selectedPrinterUUID);
    // And resume the printing that was waiting for that selection. The bulk
    // batch is already fetched and confirmed, it is printed straight away.
    if (pendingBulkLabels) {
      printBinLabels(pendingBulkLabels);
    } else {
      printLabel();
    }
  }

  //-----------------------------------------------------------------------
  // Error Dialog related states and functions
  //-----------------------------------------------------------------------

  const [messageDialog, setOpenMessage] = React.useState(false); // Boolean
  const [message, setMessage] = React.useState(); // String
  const [messageStatus, setMessageStatus] = React.useState(); // Holds MessageStatus object.

  // const [zoneNameEditDialog, setZoneNameEditDialog] = React.useState(true)

  //-----------------------------------------------------------------------
  // Logic & State related to Scan Dialog
  //-----------------------------------------------------------------------

  async function handleZone(zoneId) {
    var url = `/wms/vmi-configuration/${zoneId}`;

    setTriggeredByScan(true);
    setOpenScan(false)
    history.push(url);
  }

  const handleScanDialog = async scanId => {
    if (scanId > 100000) { // Scan PZI ID - Navigate to PZI Location

      const body = {
        "description": null,
        "code_product": null,
        "vendor_name": null,
        "ogc": null,
        "category": null,
        "limit": 10,
        "vmi": null,
        "codebin": scanId,
        "pzitbl": true,
      }

      try {
        fetchPost("products/search", body)
          .then(product => {
            if (product[0]) {
              handleZone(product[0]["zone_id"])
            } else {
              setScanError(I18n.get("profiles_noResultsFound"))
              setOpenScan(true)
            }
          })
          .catch(e => {
            console.error(e)
          })
      } catch (e) {
        console.log(e);
      }

    } else { //Scan Zone ID - Navigate to Zone Location
      handleZone(scanId)
    }
  }

  //-----------------------------------------------------------------------
  // Zone Tab Helper states and functions
  //-----------------------------------------------------------------------
  const [zoneTabIndex, setZoneTabIndex] = React.useState('pzis');
  const [zoneDeviceCount, setZoneDeviceCount] = React.useState(0);

  const handleZoneTabChange = (event, newIndex) => {
    console.log(zoneTabIndex, newIndex)

    if (editProductAssociation !== undefined || isEditMode) {
      setChangeViewDialog(true)
    } else {
      setZoneTabIndex(newIndex);
    }

  };


  //-----------------------------------------------------------------------
  // Zone Replenishment Confirmation Options
  //-----------------------------------------------------------------------

  // Replenishment Options
  const [replenishmentOptionList, setReplenishmentOptionList] = React.useState([])
  const [replenishmentOption, setReplenishmentOption] = React.useState(0)
  const [replenishmentHours, setReplenishmentHours] = React.useState(0)


  const handleReplenishmentConfirmationChange = (event) => {
    console.log(event.target.value)
    setReplenishmentOption(event.target.value);
    if (event.target.value == 169) {
      setReplenishmentHours(0)
    }
  }

  React.useEffect(() => {
    try {
      fetchGet(`attributes/280`)
        .then(data => {
          setReplenishmentOptionList(data.values.filter(v => v.active === true))
        })
        .catch(e => console.error(e))


    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSetHours = input => {
    const val = input.target.value;
    if (val === "") {
      setReplenishmentHours(parseInt(0))
    } else if (val !== "-" && val !== null && val !== undefined && !isNaN(parseInt(val))) {
      setReplenishmentHours(parseInt(val))
    }
  }


  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------

  const handleRenderViewMode = attribute => {
    if (attribute['id'] === ZONE_ATTR.UNIT_OF_MEASURE) {
      return <div>
        <div>
          {distUnitsAsObj ? distUnitsAsObj[attribute["value"]] || "-" : <></>}
        </div>
      </div>
    }
    else if (attribute['id'] === 280) {
      return <div>
        <div>
          {attribute["picklist"] ? (language === "en" ? attribute["picklist"]["name_en"] : attribute["picklist"]["name_fr"]) : "-"}
        </div>
      </div>
    }
    else {
      return <div>
        <div>
          {attribute["value"] || "-"}
        </div>
      </div>
    }

  }

  return (
    <Grid container direction="row">
      <Dialog open={searchDialogue} maxWidth={false}>
        <ProductSearch style={{ maxWidth: "1400px" }}
          componentType={"productAssociation"}
          setOpenSearch={setOpenSearch}
          associateProduct={(e) => associateProduct(e)}
          zoneBranchName={currentZoneBranchName}
        />
      </Dialog>

      <Dialog open={editWarning}
        onClose={() => { setEditWarning(false) }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <EditWarning
          language={language}
          handleNo={() => { setEditWarning(false); navigateToZone(newZoneName, newZoneID, true) }}
          handleClose={() => { setEditWarning(false) }}
          message={"save_changes"}
          handleRowClick={() => { setEdit(false); setEditWarning(false); saveEdit(newZoneName, newZoneID, true); }} />
      </Dialog>

      <Dialog open={editWarningProductAssociation !== undefined}
        onClose={() => { setEditWarningProductAssociation(undefined) }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <EditWarning
          language={language}
          handleNo={() => { setEditWarningProductAssociation(undefined); }}
          handleClose={() => { setEditWarningProductAssociation(undefined) }}
          message={"save_pzi"}
          handleRowClick={() => { setEditWarningProductAssociation(undefined); setEditProductAssociation(editWarningProductAssociation); }} />
      </Dialog>

      {/* DIALOG MOVE TREE WHEN EDITING */}
      <Dialog open={editPZIZoneNavigate}
        onClose={() => { setEditPZIZoneNavigate(false) }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <EditWarning
          language={language}
          handleNo={() => { setEditPZIZoneNavigate(false); setEditWarning(false); }}
          handleClose={() => { setEditPZIZoneNavigate(false); setEditWarning(false); }}
          message={"save_pzi"}
          handleRowClick={() => { setEditProductAssociation(undefined); setEditMode(false); setEditWarning(false); setEditPZIZoneNavigate(false); navigateToZone(tmpWarningZoneName, tmpWarningZoneID, true); }} />
      </Dialog>

      <Dialog open={zoneCreation}
        onClose={() => { createZone(false) }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <ZoneCreation
          unitMeasurements={distUnitMeasurements}
          currentNode={currentNode}
          language={language}
          handleClose={() => { createZone(false) }}
          onExpand={onToggleZone}
          expandedZones={expandedZones}
          goTo={goTo}
          setTreeDirty={setTreeDirty} />
      </Dialog>
      <Dialog open={deleteZone}
        onClose={() => { setDeleteZone(false) }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <ZoneDelete
          currentZoneID={currentZoneID}
          language={language}
          handleClose={() => { setDeleteZone(false) }}
          currentNode={currentNode}
          setEdit={setEdit}
          goTo={goTo}
          setTreeDirty={setTreeDirty}
          message={"zone_delete"} />

      </Dialog>
      <Dialog open={selectPrinterDialog}>
        <PrinterSelection
          setOpenSelectPrinter={setOpenSelectPrinter}
          updatePrinterWidthConfig={updatePrinterWidthConfig}
          devices={labelPrinterDevices}
          labelWidth={labelWidth}
        />
      </Dialog>
      <Dialog open={bulkPrintDialog}
        onClose={() => { cancelBinLabelsPrint() }}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <BulkPrintConfirmation
          count={pendingBulkLabels ? pendingBulkLabels.length : 0}
          format={bulkPrintFormat}
          zoneName={currentZoneName}
          handleClose={() => { cancelBinLabelsPrint() }}
          handleConfirm={() => { printBinLabels(pendingBulkLabels) }}
        />
      </Dialog>
      <Dialog open={scanDialog} onClose={() => { setOpenScan(false) }}>
        <ScanPopup
          setOpenScan={setOpenScan}
          errorMsg={scanError}
          setScanError={setScanError}
          handleScanDialog={handleScanDialog}

        />
      </Dialog>

      {/* DIALOG MOVE TABS WHEN EDITING */}
      <Dialog open={changeViewDialog} onClose={() => { setChangeViewDialog(false) }}>

        <EditWarning
          language={language}
          handleNo={() => { setChangeViewDialog(false) }}
          handleClose={() => { setChangeViewDialog(false) }}
          message={"save_pzi"}
          handleRowClick={() => { setChangeViewDialog(false); setEditProductAssociation(undefined); setEditMode(false); setZoneTabIndex(zoneTabIndex === "pzis" ? "devices" : "pzis") }} />
      </Dialog>
      <MessageDialog open={messageDialog}
        message={message}
        status={messageStatus}
        onClose={() => { setOpenMessage(false) }}
      />
      <Grid item>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          className={`mainContent ${classes.treeContent}`}
        >
          <div className={classes.scannerButton}>
            <NuvButton onClick={() => { setOpenScan(true) }} startIcon={<img src={images.scanner} alt="scanner" />}>
              <span>SCAN</span>
            </NuvButton>
          </div>
          <Grid
            item
            style={rootZoneId && expandedZones && expandedZones.includes(rootZoneId) ? {
              overflow: "auto",
              maxWidth: "500px",
            }
              : {
                maxWidth: "500px",
                overflowX: "auto",
                overflowY: "hidden",
              }
            }
          >
            <div>
              <ScrollableTable
                columns={[]}
                hasMore={false}
                isFetching={isFetchingTree}
                stickyHeader
              >
                {map(tree, (branch) => (
                  <ZoneTreeRow
                    key={get(branch, ["id"])}
                    branch={{
                      ...branch,
                    }}
                    depth={0}
                    language={language}
                    expandedZones={expandedZones}
                    onExpand={onToggleZone}
                    handleRowClick={navigateToZone}
                    selectedZone={parseInt(zoneId)}
                    goTo={goTo}
                    scrollToSelected={scrollToSelected}
                    setScrollToSelected={setScrollToSelected}
                  />
                ))}
              </ScrollableTable>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          className={rootZoneId && expandedZones && expandedZones.includes(rootZoneId) ? `mainContent ${classes.zoneContentExpanded}` : `mainContent ${classes.zoneContent}`}
        >
          <div>
            {
              currentZoneIDType !== ZONE_TYPE.BIN ?
                <Button onClick={() => { createZone(true) }}><img src={images.plusIconColored} alt="plus"></img>&nbsp;&nbsp;<span style={{ fontWeight: 500, color: "#0096a7", position: "relative" }}>{I18n.get("create_zone")}</span></Button>
                :
                <></>
            }
          </div>
          <div className={classes.detailParent}>
            <div style={{ float: "left" }}>
              <div className={classes.detailsTitle}>
                <span className={classes.subHeader}>{I18n.get("zone_details")}</span>
                {!editMode ? <Button className={classes.editButton} onClick={() => { setEdit(true); }}><img src={images.edit_vmi} alt="edit"></img></Button> :
                  <div style={{ top: -5 }}>
                    <Button className={classes.editButton2} onClick={() => { setEdit(false); saveEdit(currentZoneName, currentZoneID, true) }}><img src={images.save} alt="edit"></img></Button>
                    <Button className={classes.editButton2} onClick={() => { setDeleteZone(true) }}><img src={images.deleteIcon} alt="delete"></img></Button>
                    <div style={{ display: "inline-flex", top: -7 }}>
                      <CloseIcon closeFunction={() => { setEdit(false); cancelEdit(); }} />
                    </div>
                  </div>
                }


              </div>
              <div className={(currentZoneIDType !== ZONE_TYPE.BIN) ? classes.details : classes.details2} >

                {/* Label & Name Section */}
                <div className={classes.detailDiv}>
                  <NuvButton onClick={() => { printLabel() }} disabled={printingBusy} startIcon={<PrintIcon />}>
                    <span>{I18n.get("label")}</span>
                  </NuvButton>
                  {/* Bulk printing of every bin label of this level, only available
                      on the levels sitting directly above a bin. */}
                  {canBulkPrintBinLabels ?
                    <div className={classes.bulkPrintDiv}>
                      <span className={classes.bulkPrintHeader}>{I18n.get("label_printer_bulk_bins")}</span>
                      <div>
                        <NuvButton
                          onClick={() => { requestBinLabelsPrint(bulkLabel2x1) }}
                          disabled={printingBusy}
                          startIcon={<PrintIcon />}
                        >
                          <span>{bulkLabel2x1}</span>
                        </NuvButton>
                        <NuvButton
                          onClick={() => { requestBinLabelsPrint(bulkLabel4x1) }}
                          disabled={printingBusy}
                          startIcon={<PrintIcon />}
                        >
                          <span>{bulkLabel4x1}</span>
                        </NuvButton>
                      </div>
                    </div>
                    : <></>}
                  <div>
                    <span className={classes.detailHeader}>{I18n.get("site_name")}</span>
                  </div>

                  <div>
                    {editMode && ZONE_TYPES_WITH_EDITABLE_NAMES.includes(currentZoneIDType) ?
                      <div style={{ width: 240 }}>
                        <CustomInput
                          name="zone_name"
                          value={currentZoneNameTmp}
                          onChange={(e) => { if (e.target.value.length < 5) setSelectedZoneNameTmp(e.target.value) }}
                        />
                      </div>
                      :
                      <>
                        {currentZoneName}
                      </>
                    }
                  </div>
                </div>

                {/* Zone Type Section */}
                <div className={classes.detailDiv}>
                  <div>
                    <span className={classes.detailHeader}>{I18n.get("site_type2")}</span>
                  </div>
                  <div>
                    {currentZoneType}
                  </div>
                </div>

                {/* Description, Comments & Replenishment Section Dynamic UI for View/Edit Mode */}
                {editMode ?
                  map(zoneAttributesTmp, (attribute, i) => (

                    <div className={classes.detailDiv} key={attribute['id']}>
                      <div>
                        {attribute['required'] === true &&
                          <span style={{ color: colors.errorRed, paddingRight: "3px" }}>
                            {"* "}
                          </span>
                        }
                        <span className={classes.detailHeader}>{attribute[`name_${language}`]}</span>
                      </div>
                      {
                        attribute['id'] === ZONE_ATTR.UNIT_OF_MEASURE ?
                          <div style={{ width: 240 }}>
                            <CustomSelect
                              name={"type"}
                              value={attribute['value']}
                              noSort={true}
                              options={distUnitMeasurements}
                              onChange={(e) => {
                                // setUnitSelected(e.target.value);
                                const newElements = { ...zoneAttributesTmp }
                                newElements[i].value = e.target.value
                                setZoneAttributesTmp(newElements)
                              }}
                            />
                          </div>
                          :
                          attribute['id'] === ZONE_ATTR.RESPONSIBILITY_CENTER ?
                            <div style={{ width: 240 }}>
                              <CustomSelect
                                name={attribute[`name_${language}`]}
                                value={attribute['value']}
                                noSort={true}
                                options={ZONE_RESPONSIBILITY_CENTER_OPTIONS}
                                onChange={(e) => {
                                  const newElements = { ...zoneAttributesTmp }
                                  newElements[i].value = e.target.value
                                  setZoneAttributesTmp(newElements)
                                }}
                              />
                            </div>
                            :
                            attribute['id'] === 254 || attribute['id'] === 253 || attribute['id'] === 252 ?
                              <div style={{ width: 70 }}>
                                <CustomInput
                                  name={attribute[`name_${language}`]}
                                  value={attribute["value"] || ""}
                                  onChange={(e) => {
                                    const newElements = { ...zoneAttributesTmp }
                                    newElements[i].value = e.target.value
                                    setZoneAttributesTmp(newElements)
                                  }}
                                  type={attribute["data_type"] === "float" || attribute["data_type"] === "integer" ? "number" : "text"}
                                  step={attribute["data_type"] === "float" ? "0.01" : ""}
                                />
                              </div>
                              :
                              attribute['id'] === 280 ?
                                <>
                                  <div style={{ width: 240 }}>
                                    <Select
                                      value={replenishmentOption}
                                      onChange={handleReplenishmentConfirmationChange}
                                      className={classes.paginationDropdown}
                                      disableUnderline
                                    >
                                      {replenishmentOptionList.map(r =>
                                        <MenuItem value={r.id}>{language === "en" ? r.name_en : r.name_fr}</MenuItem>
                                      )}
                                    </Select>
                                  </div>

                                  {replenishmentOption === 167 ?
                                    <>
                                      <div style={{ marginTop: "8px" }}>
                                        <span className={classes.detailHeader}>{capitalizeFirstLetter(I18n.get("dashboard_hours"))}</span>
                                      </div>
                                      <div style={{ width: 70 }}>
                                        <CustomInput
                                          value={replenishmentHours}
                                          onChange={(e) => {
                                            handleSetHours(e)
                                          }}
                                        />
                                      </div>
                                    </>
                                    : null}

                                </>
                                :
                                <div style={{ width: 240 }}>
                                  <CustomInput
                                    name={attribute[`name_${language}`]}
                                    value={attribute["value"] || ""}
                                    onChange={(e) => {
                                      const newElements = { ...zoneAttributesTmp }
                                      newElements[i].value = attribute["id"] === 227 && e.target.value.length >= 35 ? e.target.value.substring(0, 35) : e.target.value;
                                      setZoneAttributesTmp(newElements)
                                    }}
                                    type={attribute["data_type"] === "float" || attribute["data_type"] === "integer" ? "number" : "text"}
                                    step={attribute["data_type"] === "float" ? "0.01" : ""}
                                  />
                                </div>
                      }
                    </div>
                  ))
                  :
                  <>
                    {map(zoneAttributes, (attribute, i) => (
                      // View Mode
                      <div className={classes.detailDiv} key={attribute['id']}>
                        <div>
                          <span className={classes.detailHeader}>{attribute[`name_${language}`]}</span>
                        </div>
                        {
                          handleRenderViewMode(attribute)
                        }
                      </div>
                    ))}

                    {replenishmentOption === 167 && currentZoneIDType === 30 ?

                      <div className={classes.detailDiv} key={167}>
                        <div>
                          <span className={classes.detailHeader}>{capitalizeFirstLetter(I18n.get("dashboard_hours"))}</span>
                        </div>
                        {
                          handleRenderViewMode({ value: replenishmentHours })
                        }
                      </div>
                      : null}
                  </>
                }

              </div>
            </div>
            {/* TODO: the style is due to the bad structure of the parent divs and need to be fixed */}
            <div className={classes.detailRight} style={rootZoneId && expandedZones && expandedZones.includes(rootZoneId) ? { marginLeft: 30, float: "right", right: 40 } : { marginLeft: 0, float: "right", right: 40 }}>
              <TabContext value={zoneTabIndex}>
                <PaperLightGrey elevation={0}>
                  <NuvTabList
                    onChange={handleZoneTabChange}
                    aria-label="zone nav tabs"
                  >
                    <NuvTab label={I18n.get("associated_products") + " (" + products.length + ")"} value={'pzis'}></NuvTab>
                    <NuvTab label={I18n.get("companies_devices") + " (" + zoneDeviceCount + ")"} value={'devices'}></NuvTab>
                    {/* <NuvTab label="Test" value={'test'}></NuvTab> */}
                  </NuvTabList>
                </PaperLightGrey>
                <NuvTabPanel value={'pzis'}>
                  <PaperLightGrey elevation={0}>
                    {((currentZoneIDType !== ZONE_TYPE.BIN) || (products.length === 0)) && ZONE_TYPES_WITH_INVENTORY_ICON.includes(currentZoneIDType) ?
                      <div className={classes.detailsTitle3}>
                        {
                          !isAwaitingRequest ?
                            <Button onClick={() => { setOpenSearch(true) }}><img src={images.link} alt="plus"></img>&nbsp;&nbsp;<span style={{ fontWeight: 500, color: "#0096a7", position: "relative" }}>{I18n.get("associate_product")}</span></Button>
                            :
                            null
                        }
                      </div>
                      : <></>}
                    <div className={((currentZoneIDType !== ZONE_TYPE.BIN) && (products.length === 0)) ? classes.detailsProduct3 : ((currentZoneIDType === ZONE_TYPE.BIN) && (products.length !== 0)) ? classes.detailsProduct2 : classes.detailsProduct}>
                      {map(products, (product, i) => (
                        <ProductAssociation
                          key={product['id']}
                          componentId={i}
                          language={language}
                          data={product}
                          removeProduct={() => { products.splice(i, 1); fetchRootTree(); }}
                          updateProduct={() => { fetchProductZoneInventories(currentZoneID); }}
                          massUnitsAsObj={massUnitsAsObj}
                          massUnitMeasurements={massUnitMeasurements}
                          minQuantLevelOptions={minQuantLevelOptions}
                          maxQuantLevelOptions={maxQuantLevelOptions}
                          setEditProductAssociation={setEditProductAssociation}
                          editProductAssociation={editProductAssociation}
                          setEditWarningProductAssociation={setEditWarningProductAssociation}
                        />
                      ))}

                    </div>
                  </PaperLightGrey>
                </NuvTabPanel>
                <ZoneDevicePanel
                  value={'devices'}
                  companyId={currentCompanyID}
                  siteId={currentSiteID}
                  zoneId={currentZoneID}
                  setZoneDeviceCount={setZoneDeviceCount}
                  hasZoneSpacer={(currentZoneIDType !== ZONE_TYPE.BIN)}
                  isEditMode={isEditMode}
                  setEditMode={setEditMode}
                />
                {/*<NuvTabPanel value={'test'}>
                  Nothing for now.
                  <div>rootZoneId = {rootZoneId}</div>
                </NuvTabPanel>*/}
              </TabContext>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    zones: get(state, ["zones"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(Zone))
);
